module.exports = __webpack_public_path__ + "img/diferencial1.94c8e036.png";